export const actionTypes = {
  SET_FAIRVALUE: "SET_FAIRVALUE",
  SET_LOADING: "SET_LOADING",
};
